<div>
    {{field.getDisplayValue(focusItem)}}
</div>
